<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="6"
		/>
        <selectInput
            @inputTxtFunc = "(e)=>{ set_val(e, 'status'); }"
            label="ثبت نتیجه ارزیابی"
            :flds="[
                {'id': '11','name': 'نقص مدارک'},
                {'id': '1','name': 'تایید شد/فعال'},
                {'id': '2','name': 'تایید شد/غیرفعال'},
                {'id': '12','name': 'رد شد'}
            ]"
            :value="val.value.status"
        />
        <textareaInput
        :value="val.value.comment"
        @blurinputTxtFunc="(e)=>{ set_val(e, 'comment'); }"
        label="توضیحات"
        placeholder="توضیحات اپراتور در اینجا نوشته شود..."
        v-if="val.value.status == 11 || val.value.status == 12 "
        />
    <!-- ************************************************************* -->
    <br>
    <br>
    <br>
        <btn
            text=" ثبت "
            textClass="w-100 mt-3"
            @clickMe="sav_final()"
        />
	</div>
    <!-- ************************************************************* -->
</template>

<script>
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import btn from "../../UI/button/btn.vue";
    import selectInput from  "../../UI/input/selectInput.vue";
	import textareaInput from  "../../UI/input/textareaInput.vue";

	export default {
		name: 'wait_signup',
		data(){
			return {
                fld: ['status', 'comment']
			}
		},
		components: {
			btn,
            textareaInput,
			multi_step_progress,
            selectInput,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){

		},
		methods:{
            set_val(val, fild){
                if(val>0){
                    this.val.value[fild] = val;
                    if(this.$localStorage.get('user')) {
                        window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: fild ,val: val, id: this.val.id, admin: this.$localStorage.get('user')}, function () {}, "json");
                    } else {
                        window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: fild ,val: val, id: this.val.id}, function () {}, "json");
                    }
                }
            },
            sav_final(){
                this.$router.go(-1);
                // for (let i = 0; i < this.fld.length; i++) {
                //     window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: this.fld[i] ,val: this.val.value[this.fld[i]], id: this.val.id}, function () {}, "json");
                //     if(i == (this.fld.length-1)){
                //         this.$router.go(-1);
                //     }
                // }
            },
		}
	}
</script>
<style>

</style>
